@if (isMenuSearchActive) {
  <p-autocomplete [(ngModel)]="selected" [suggestions]="searchMenuResults" (completeMethod)="searchMenuItem($event)"
    (onSelect)="selectMenuItem($event)" field="name"
    placeholder="{{'QuickNav' | localize}}" [minLength]="1" inputStyleClass="form-control menuSearchBarInput"
    styleClass="menuSearchBarContainer">
  </p-autocomplete>
}